/* Search overlay — opens below header, live results via Predictive Search Section Rendering API.
   PREVIEW GATE: while ENABLED=false the overlay only activates with ?searchpreview=1 (persisted for the session).
   Flip ENABLED to true to launch for everyone. */
(function () {
  var ENABLED = false; /* <- flip to true to go live for all visitors */

  var params = new URLSearchParams(window.location.search);
  if (params.has('searchpreview')) {
    try { sessionStorage.setItem('tgcSearchPreview', '1'); } catch (e) {}
  }
  var preview = false;
  try { preview = sessionStorage.getItem('tgcSearchPreview') === '1'; } catch (e) {}
  if (!ENABLED && !preview) return;

  var overlay = document.getElementById('tgc-search-overlay');
  if (!overlay) return;

  var input = overlay.querySelector('[data-so-input]');
  var results = overlay.querySelector('[data-so-results]');
  var panel = overlay.querySelector('.search-overlay__panel');
  var predictiveUrl = overlay.getAttribute('data-predictive-url') || '/search/suggest';
  var triggers = document.querySelectorAll('.new-header__icon-search-mobile, .new-header__icon-link[href*="/search"]');
  var debounceTimer = null;
  var controller = null;
  var lastTerm = '';

  function headerBottom() {
    var hdr = document.querySelector('.new-header');
    if (!hdr) return 0;
    var r = hdr.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }

  function open() {
    overlay.hidden = false;
    panel.style.top = headerBottom() + 'px';
    document.body.classList.add('so-open');
    triggers.forEach(function (t) { t.classList.add('so-active'); });
    window.requestAnimationFrame(function () { input.focus(); });
  }

  function close() {
    overlay.hidden = true;
    document.body.classList.remove('so-open');
    triggers.forEach(function (t) { t.classList.remove('so-active'); });
    input.value = '';
    results.innerHTML = '';
    lastTerm = '';
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = predictiveUrl +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,article' +
      '&resources[limit]=4' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag,body' +
      '&section_id=predictive-search-overlay';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.shopify-section');
        results.innerHTML = inner ? inner.innerHTML : '';
      })
      .catch(function (err) { if (err.name !== 'AbortError') console.error('[search-overlay]', err); });
  }

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length < 2) { results.innerHTML = ''; lastTerm = ''; return; }
    debounceTimer = setTimeout(function () {
      if (term === lastTerm) return;
      lastTerm = term;
      fetchResults(term);
    }, 250);
  });

  overlay.querySelectorAll('[data-so-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });

  triggers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      if (overlay.hidden) open(); else close();
    });
  });

  window.addEventListener('resize', function () {
    if (!overlay.hidden) panel.style.top = headerBottom() + 'px';
  });
})();
